module.exports = __webpack_public_path__ + "img/platformBanner.38b41416.jpg";